import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a6c405f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0a6c405f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c405f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6c405f')) {
      api.createRecord('0a6c405f', component.options)
    } else {
      api.reload('0a6c405f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a6c405f&scoped=true&", function () {
      api.rerender('0a6c405f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TinymceEditor/index.vue"
export default component.exports